import React from 'react';
import { DollarSign, Hammer, Grid, Layers, Droplets } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
export function CostFactorsSection() {
  const factors = [{
    icon: DollarSign,
    title: 'Finish Complexity',
    desc: 'Broom ($) → Exposed Aggregate ($$) → Stamped ($$$)'
  }, {
    icon: Hammer,
    title: 'Stamping Labor',
    desc: 'Pattern complexity, color layers, and detail work add time'
  }, {
    icon: Grid,
    title: 'Saw Cuts & Joints',
    desc: 'More cuts = less cracking risk but more labor'
  }, {
    icon: Layers,
    title: 'Reinforcement',
    desc: 'Rebar vs mesh vs fiber—depends on load and span'
  }, {
    icon: Droplets,
    title: 'Sealing',
    desc: 'Initial seal + ongoing reapplication schedule'
  }];
  return <section className="py-16 bg-slate-50 md:py-24" data-id="element-133">
      <div className="container mx-auto px-4 md:px-6" data-id="element-134">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-135">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-136">
            Understanding Price Without the Sticker Shock
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-137">
            What drives the cost of your finish? It's usually labor and
            complexity.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-138">
          {factors.map((factor, index) => <Card key={index} className="border-slate-200 hover:border-primary/30 transition-colors" data-id="element-139">
              <CardContent className="pt-6" data-id="element-140">
                <div className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center mb-4 text-slate-600 shadow-sm" data-id="element-141">
                  <factor.icon className="h-5 w-5" data-id="element-142" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2" data-id="element-143">
                  {factor.title}
                </h3>
                <p className="text-sm text-slate-600" data-id="element-144">{factor.desc}</p>
              </CardContent>
            </Card>)}
        </div>

        <div className="text-center" data-id="element-145">
          <p className="text-sm text-slate-500 italic bg-white inline-block px-4 py-2 rounded-full border border-slate-200" data-id="element-146">
            We don't publish prices because every project is different. But we
            will give you a fixed-scope quote with no surprises after the site
            visit.
          </p>
        </div>
      </div>
    </section>;
}